<template>
  <b-card>
    <b-card-title class="mb-1">ตั้งค่านำเข้ามาตรฐาน</b-card-title>
    <!-- <b-card-sub-title class="mb-2">
      เรทกลางที่ใช้กับลูกค้าทุกคน (ลูกค้าที่ไม่ได้ตั้งเรทเฉพาะจะใช้ค่านี้)
    </b-card-sub-title> -->
    <shipping-rate-grid :customer-id="0" />
  </b-card>
</template>

<script>
import { BCard, BCardTitle, BCardSubTitle } from 'bootstrap-vue'
import ShippingRateGrid from './ShippingRateGrid.vue'

export default {
  components: { BCard, BCardTitle, BCardSubTitle, ShippingRateGrid },
}
</script>
